import type {ActionResponse, Auth} from 'typings/portaro.be.types';
import {transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {RecordDemand} from './acquisition.types';
import type FinishedResponseInteractionService from '../../commons/services/finished-response-interaction.service';

export default class AcquisitionController {

    /*@ngInject*/
    constructor(private walker, private currentAuth: Auth, private Restangular: Restangular.IService, private finishedResponseInteractionService: FinishedResponseInteractionService) {}

    @unRestangularize()
    public async saveRecordDemand(recordDemand: RecordDemand): Promise<ActionResponse> {
        return this.Restangular
            .one('record-demands')
            .post(null, transferify(recordDemand));
    }

    public createRecordDemand() {
        return this.saveRecordDemand({
                id: null,
                record: null,
                creator: this.currentAuth.activeUser,
                createDate: new Date(),
                department: null
            })
            .then((response) => this.finishedResponseInteractionService.showSuccessResponseInModalWindow(response))
            .catch((error) => this.finishedResponseInteractionService.showFailedResponseInModalWindow(error));
    }
}
